import {useMemo} from 'react';
import {PAGINATION_DEFAULT} from 'modules/products/context';
import {TGetListingTransformedResponse} from 'plugins/modules/listing/types';
import {ISearchMeta} from 'modules/products/types';

interface IListingValues<IProduct> {
    data?: TGetListingTransformedResponse<IProduct, unknown>;
}

export const useListingValues = <Product>({data}: IListingValues<Product>) => {
    const pagination = useMemo(
        () => ({
            ...(data?.pagination || PAGINATION_DEFAULT),
            pageNumber: data?.pagination?.pageNumber || PAGINATION_DEFAULT.pageNumber,
        }),
        [data?.pagination],
    );

    const meta = data?.meta;
    const seo = data?.seo;
    const list = data?.list || [];
    const searchMeta = (data as {searchMeta?: ISearchMeta} | undefined)?.searchMeta;

    return {
        meta,
        seo,
        list,
        pagination,
        searchMeta,
    };
};
